import React from 'react'
import { useTranslation } from 'react-i18next'
import Select from '../../../packages/kiti/components/form/Select'

const SlaTypeSelect = ({ mergeOptions = [], returnObject, ...props }) => {
  const { t } = useTranslation('serviceOrders')
  const options = [
    { name: t('slaType.creationDate'), id: 'creationDate' },
    { name: t('slaType.schedulingDate'), id: 'schedulingDate' }
  ]

  return <Select options={options} selectOnlyId={returnObject ? false : true} {...props} />
}

export default SlaTypeSelect
